import { selectCurrentUser } from 'store/auth/selectors';
import { useSelector } from 'store/utils';
import { UserRole } from 'types';

type Props = {
  rolesAllowedToView: Array<UserRole>;
  children: React.ReactNode;
};

export const RolePermissionChecker = ({ rolesAllowedToView, children }: Props) => {
  const currentUser = useSelector(selectCurrentUser);
  const currentUserRole = currentUser?.role;
  const isAllowed = currentUserRole && rolesAllowedToView.includes(currentUserRole);

  if (!isAllowed) return null;

  return <>{children}</>;
};
